// extracted by mini-css-extract-plugin
export default {"sound_container":"Notification_sound_container__hrLll","selectedStyle":"Notification_selectedStyle__nTFka","prefernce_m_list_item":"Notification_prefernce_m_list_item__OfDQk"};